export default __webpack_public_path__ + "static/pool-thumb-dfdad1497b90d73ceb2e8b9e2c27d28f.jpg";